import { render, staticRenderFns } from "./DietTable.vue?vue&type=template&id=b925c2ac&scoped=true&"
import script from "./DietTable.vue?vue&type=script&lang=js&"
export * from "./DietTable.vue?vue&type=script&lang=js&"
import style0 from "./DietTable.vue?vue&type=style&index=0&id=b925c2ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925c2ac",
  null
  
)

export default component.exports